<template>
    <div v-show="shouldShow && isShowingPaidAmountInput()">
        <select title="Payment Methods"
                class="form-control"
                v-model="entry.payment_method_id"
                @change="onPaymentMethodChanged"
                v-bind:class="{ 'is-invalid' : paymentMethodError }">
            <option disabled value="">Select Pay Method...</option>
            <option v-for="(paymentMethod, id) in paymentMethods"
                    :value="id">
                {{ paymentMethod }}
            </option>
        </select>
        <small class="invalid-feedback d-block"
               v-show="paymentMethodError !== ''">
            {{ paymentMethodError || '' }}
        </small>
        <select title="Bank Accounts"
                class="form-control mt-10"
                v-model="entry.bank_account_id"
                v-show="bankAccounts[entry.payment_method_id]"
                v-bind:class="{ 'is-invalid' : bankAccountError }">
            <option disabled value="">Select Account...</option>
            <option v-for="(bankAccount, id) in bankAccounts[entry.payment_method_id]"
                    :value="id">
                {{ bankAccount }}
            </option>
        </select>
        <small class="invalid-feedback d-block"
               v-show="bankAccountError !== ''">
            {{ bankAccountError || '' }}
        </small>
        <input type="text"
               autocomplete="off"
               title="Transaction ID"
               placeholder="Transaction ID"
               v-model="entry.bank_transaction_id"
               v-show="bankAccounts[entry.payment_method_id]"
               v-bind:class="{ 'is-invalid' : bankTransactionIdError }"
               class="form-control mt-10"/>
        <small class="invalid-feedback d-block"
               v-show="bankTransactionIdError !== ''">
            {{ bankTransactionIdError || '' }}
        </small>
        <DatePicker v-show="bankAccounts[entry.payment_method_id]"
                    :reference="`bank_transaction_date`"
                    :on-change="onDateChanged"
                    :value="null"
                    date-format="YYYY-MM-DD"
                    :extras="{ endDate: '+0d' }"
                    :error="bankTransactionDateError"/>
    </div>
</template>

<script>
import DatePicker from "../../../components/DatePicker";

export default {
    components: {
        DatePicker,
    },
    props: {
        entry: {
            type: Object,
            required: true,
        },
        paymentMethods: {
            type: Object,
            required: true,
        },
        bankAccounts: {
            type: Object,
            required: true,
        },
        shouldShow: {
            type: Boolean,
            required: false,
            default: true,
        },
        paymentMethodError: {
            type: String,
            required: false,
        },
        bankAccountError: {
            type: String,
            required: false,
        },
        bankTransactionIdError: {
            type: String,
            required: false,
        },
        bankTransactionDateError: {
            type: String,
            required: false,
        },
    },
    methods: {
        isShowingPaidAmountInput() {
            return (this.entry.amount - this.entry.waived_amount) > 0
        },
        onDateChanged(ref, date) {
            this.entry.bank_transaction_date = date
        },
        onPaymentMethodChanged(ref, paymentMethodId) {
            if (!this.bankAccounts[paymentMethodId]) {
                this.entry.bank_account_id = null
                this.entry.bank_transaction_id = null
                this.entry.bank_transaction_date = null
            }
        },
    }
}
</script>

<style scoped>

</style>
